import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { SessionReportScoreDonut } from "./Summary/SessionReportScoreDonut";

export type SessionReportSkill = {
	id: string | number;
	label: string;
	icon: IconType;
	score: number;
};

type Props = {
	skills: SessionReportSkill[];
	numItems: number;
	maxScore: number;
};

export const SessionReportSkillCard = ({
	skills,
	numItems,
	maxScore,
}: Props) => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<FlatCard style={isMobile ? { borderRadius: 0 } : undefined}>
			<Box paddingTop={16} paddingHorizontal={16} paddingBottom={24} gap={16}>
				<Box justifyContent="center" gap={4}>
					<Text variant="titleMedium" style={{ color: theme.colors.onSurface }}>
						{t("report.skillsBreakdown.title")}
					</Text>
					<Text variant="bodySmall" style={{ color: theme.colors.onSurface }}>
						{t("report.skillsBreakdown.subtitle", { count: numItems })}
					</Text>
				</Box>
				<Box
					flexDirection="row"
					flexWrap={isMobile ? "wrap" : "nowrap"}
					justifyContent="center"
					alignItems="flex-start"
					columnGap={isMobile ? 24 : 62}
					rowGap={24}
					width="100%"
				>
					{skills.map((skill) => (
						<Box
							key={skill.id}
							width={isMobile ? "42%" : undefined}
							alignItems="center"
						>
							<SessionReportScoreDonut
								label={skill.label}
								icon={skill.icon}
								score={skill.score}
								maxScore={maxScore}
								progress={skill.score / maxScore}
								size="compact"
							/>
						</Box>
					))}
				</Box>
			</Box>
		</FlatCard>
	);
};
